import { getEnvironmentName } from '@features/serverBots/utils/getEnvironmentName'
import { BotId } from '@feedyou/schema'
import { botMetadataSelector } from '@features/serverBots/selectors/botMetadataSelector'

import { RootState } from '../../../reducers'
import { EnvironmentGroupDescriptor } from '../types'
import { botMetadataForEnvironmentGroupSelector } from './botMetadataForEnvironmentGroupSelector'

export const environmentGroupForBotSelector =
  (id: BotId | undefined) =>
  (state: RootState): EnvironmentGroupDescriptor => {
    const environmentGroupId = botMetadataSelector(id)(state)?.environmentGroupId
    const metadata = botMetadataForEnvironmentGroupSelector(environmentGroupId!)(state)

    const testId = metadata?.find(m => m.environmentType === 'test')?.id
    const prodId = metadata?.find(m => m.environmentType === 'prod')?.id

    const testName = getEnvironmentName(
      metadata?.find(m => m.environmentType === 'test'),
      'test'
    )

    const prodName = getEnvironmentName(
      metadata?.find(m => m.environmentType === 'prod'),
      'prod'
    )

    return {
      environmentGroupId: environmentGroupId ?? null,
      testId: testId ?? null,
      prodId: prodId ?? null,
      testName,
      prodName
    }
  }
